import { useEffect, useRef, useState } from 'react'
import { Button, Table } from 'antd'
import { useNavigate, useParams } from 'react-router-dom';
import { loadingPlanService } from '../../../services';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { changeDocumentTitle } from '../../../utils/title';

export default function LoadPlanPdf() {

    const { id } = useParams();
    const pdfRef = useRef();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false)
    const [container, setContainer] = useState([]);
    const [vehicles, setVehicles] = useState([]);

    const columns = [
        {
            title: "S.NO",
            dataIndex: 'Sno',
            key: 'Sno',
            align: "center",
            // width: 30,
            render: (text, record, index) => index + 1,
        },
        {
            title: "REF#",
            dataIndex: 'file_ref',
            key: 'Ref',
            align: "center",
            // width: 20,
        },
        {
            title: "YR",
            dataIndex: 'year',
            key: 'Year',
            align: "center",
            // width: 20,
        },
        {
            title: "MAKE/MODEL & PRODUCT",
            dataIndex: 'MakeModelProduct',
            key: 'MakeModelProduct',
            align: "center",
            // width: 200,
            render: (text, record) => {
                if (record?.vehicle || record?.product) {
                    return `${record.vehicle || ""} - ${record?.product || ""}`;
                }
                return 'N/A';
            }
        },
        {
            title: "Vin#",
            dataIndex: 'chasis_no',
            key: 'VinNumbers',
            align: "center",
            // width: 50,

        },
        {
            title: "KEY",
            dataIndex: 'keys',
            key: 'Keys',
            align: "center",
        },
    ]


    const downloadPDF = async () => {
        setLoading(true);

        const element = pdfRef.current;

        // Render the HTML content to a canvas
        const canvas = await html2canvas(element, { scale: 2 });

        // Convert the canvas to an image
        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");

        // Get A4 page width in mm
        const pdfWidth = pdf.internal.pageSize.getWidth();

        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const pdfHeight = (canvasHeight * pdfWidth) / canvasWidth;

        // Define margins (in mm)
        const topMargin = 5;
        const bottomMargin = 10;

        // Adjust the PDF height to account for the margins
        const adjustedPdfHeight = pdfHeight + topMargin + bottomMargin;
        pdf.internal.pageSize.height = adjustedPdfHeight;

        // Add the canvas image to the PDF with margins
        pdf.addImage(imgData, "PNG", 0, topMargin, pdfWidth, pdfHeight, undefined, "FAST");

        // Save the PDF
        pdf.save("Load Plan " + id + ".pdf");
        setLoading(false);
    };

    const initialize = async () => {
        const { success, data } = await loadingPlanService.ViewPDF(id);
        if (success) {
            setContainer(data.loadplanpdf);
            const allvehicles = data.containers.map((container) => container.vehicle);
            setVehicles(allvehicles)
        }
    }

    useEffect(() => {
        changeDocumentTitle("View PDF");
         initialize();
    }, [])
    return (
        <>
            <Button
                style={{ backgroundColor: "#DC3545", color: "white" }}
                onClick={downloadPDF}
                loading={loading}
            >
                Download PDF
            </Button>
            <Button
                style={{ backgroundColor: "#DC3545", color: "white", marginLeft: 10 }}
                onClick={() => navigate(`/operations/loadings/generates-plans/${id}`,
                    { state: { sealNo: container?.seal_number, isEdit: true, verifier: container?.verifier_name, note: container?.special_note } })
                }
                loading={loading}
            >
                Edit PDF
            </Button>
            <div ref={pdfRef} style={{ display: "flex", flexDirection: "column", width: '100%', alignItems: "center", margin: "0 auto" }} >
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '80%',
                }}>

                    <img src="/images/ctrade-logo.png" alt="" width="130px" />

                    <h1 style={{ textAlign: "center", fontSize: 30, fontWeight: "bold", marginTop: 50, color: "#B83D3D" }}>
                        LOADING PLAN
                    </h1>
                </div>

                <div
                    style={{
                        position: 'relative',
                        border: '2px solid black',
                        width: "90%",
                        backgroundColor: '#fff',
                        overflow: 'hidden',
                    }}
                >
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundImage: 'url("/images/ctrade-logo.png")',
                            backgroundSize: '600px',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            opacity: 0.15,
                            zIndex: 0,
                        }}
                    ></div>

                    <div >
                        {container?.special_note &&
                            <p style={{ borderBottom: '2px solid black', padding: 3, textAlign: 'center', fontSize: 24, fontWeight: 500 }}>
                                <b>{container?.special_note}</b>
                            </p>
                        }
                        <p style={{ borderBottom: '2px solid black', padding: 3, textAlign: 'center', fontSize: 20, fontWeight: '' }}>
                            LOAD PLAN: {container?.load_number}
                        </p>
                        <p style={{ borderBottom: '2px solid black', padding: 3, textAlign: 'center', fontSize: 20, fontWeight: '' }}>
                            CONTAINER NO: {container?.container_number}
                        </p>
                        <p style={{ borderBottom: '2px solid black', padding: 3, textAlign: 'center', fontSize: 20, fontWeight: '' }}>
                            SEAL NO: {container?.seal_number}
                        </p>
                        <p style={{ padding: 3, textAlign: 'center', fontSize: 20, fontWeight: '' }}>
                            SIZE : {container?.size}
                        </p>
                        <Table columns={columns} dataSource={vehicles} pagination={false} style={{ marginTop: 0, backgroundColor: "transparent" }} className="transparent-table"
                        />

                        <p style={{ borderBottom: '2px solid black', padding: 3, textAlign: 'center', fontSize: 18, fontWeight: "bold", marginTop: 10 }}>Notes</p>
                        <p style={{ borderBottom: '2px solid black', padding: 3, textAlign: 'center', fontSize: 15, fontWeight: 'bold' }}>
                            Need 30 PICTURES MINIMUM FOR EACH CONTAINER LOADING PROCESS.
                        </p>
                        <p style={{ borderBottom: '2px solid black', padding: 3, textAlign: 'center', fontSize: 15, fontWeight: 'bold' }}>
                            ALWAYS TAKE PICTURE OF CATALYTIC CONVERTER FOR EACH CAR WHILE LOADING. (4 OR 3 EXTRA PICTURES)
                        </p>
                        <p style={{ borderBottom: '2px solid black', padding: 3, textAlign: 'center', fontSize: 15, fontWeight: 'bold' }}>
                            PICTURE OF CAR GETTING INSIDE OF CONTAINER IS A MUST.
                        </p>
                        <p style={{ borderBottom: '2px solid black', padding: 3, textAlign: 'center', fontSize: 15, fontWeight: 'bold' }}>
                            NEED A CLEAR PICTURE OF CAR REF#, CAR COLOR SHOULD BE VISIBLE (NO DARK PICTURES)
                        </p>
                        <p style={{ borderBottom: '2px solid black', padding: 3, textAlign: 'center', fontSize: 15, fontWeight: 'bold' }}>
                            CONTAINER WILL NOT LEAVE THE DOCK UNTIL IT'S VERIFIED BY SYED HAIDER
                        </p>
                        <p style={{ textAlign: 'center', fontSize: 15, fontWeight: 'bold' }}>
                            IT'S MANDATORY THAT AUTOMOBILE BATTERIES MUST BE DISCONNECTED AND INSULATED, AND THE AUTOMOBILE FUEL TANK MUST BE DRAINED.
                        </p>
                    </div>
                </div>
            </div>
            <style>{`
                    
.transparent-table .ant-table {
  background-color: transparent !important;
}
.transparent-table .ant-table-cell {
  font-size: 15px !important;
}

/* Ensure headers and rows are also transparent */
.transparent-table .ant-table-thead > tr > th,
.transparent-table .ant-table-tbody > tr > td {
  background-color: transparent !important;
}

/* Make table borders black and bold */
.transparent-table .ant-table,
.transparent-table .ant-table-thead > tr > th,
.transparent-table .ant-table-tbody > tr > td {
  border: 1px solid black !important;
  font-weight: bold;
  border-radius: 0 !important; /* Remove border radius */
}

/* Remove left border from the first column */
.transparent-table .ant-table-thead > tr > th:first-child,
.transparent-table .ant-table-tbody > tr > td:first-child {
  border-left: none !important;
}

/* Remove right border from the last column */
.transparent-table .ant-table-thead > tr > th:last-child,
.transparent-table .ant-table-tbody > tr > td:last-child {
  border-right: none !important;
}



            `} </style>
        </>
    )
}
